import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { PujaPrasadService } from '../puja-prasad.service';
import { PujaPrasadOrderService } from '../puja-prasad-order.service';
import { PujaPrasadOrderVM } from '../puja-prasad-order-vm';
import { DevoteeDetail } from '../../Devotee/devotee-detail';
import { PujaPrasadOrderResponse } from '../puja-prasad-order-response';
import { RazorpayService } from '../razorpay.service';

@Component({
  selector: 'app-my-puja-prasad-order',
  templateUrl: './my-puja-prasad-order.component.html',
  styleUrls: ['./my-puja-prasad-order.component.css'],
  providers: [PujaPrasadService, PujaPrasadOrderService]
})
export class MyPujaPrasadOrderComponent implements OnInit {



  constructor(private activeRoute: ActivatedRoute,
    private sharedService: SharedService,
    private pujaPrasadService: PujaPrasadService,
    private pujaPrasadOrderService: PujaPrasadOrderService,
    private razorpayService: RazorpayService) { }

  successMessage: string;
  errorMessage: string;
  pujaPrasadOrderList: any = [];
  testing: any[] = [];
  totalCartAmount: number = 0;
  devoteeDetail: DevoteeDetail;

  ngOnInit() {

    this.devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();

    this.activeRoute.params.subscribe(params => this.loadMessage(params.msg));

    this.pujaPrasadOrderList = [];
    this.loadDevoteePujaPrasadList();

  }


  private loadDevoteePujaPrasadList(): void {
    this.sharedService.showSpinner();
    this.pujaPrasadOrderService.getDevoteeOrders().subscribe(
      data => {

        this.pujaPrasadOrderList = data.PujaPrasadOrders;

        this.sharedService.hideSpinner();
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      }
    )
  }

  private loadMessage(routeMsg: string) {
    if (routeMsg == "razorpaySuccess") {
      this.successMessage = "We received your prasad order";
    }
    else if (routeMsg == "razorpayFalied") {
      this.errorMessage = "We recived your prasad order, But payment has failed, please retry payment";
    }
    else if (routeMsg == "razorpayClosed") {
      this.errorMessage = "We recived your prasad order, But not get payment confirmation, please retry payment";
    }
  }



  public paymentRetry(orderId: number): void {
    this.errorMessage = "";
    this.successMessage = "";
    this.sharedService.showSpinner();
    var paymentRetryRequest = {
      PujaPrasadOrderId: orderId,
      mobileNo: this.devoteeDetail.MobileNo
    };
    this.pujaPrasadOrderService.paymentRetry(paymentRetryRequest).subscribe(
      data => {
        this.makePayment(data);

        this.sharedService.hideSpinner();
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      }
    )
  }



  makePayment(pujaPrasadOrderResponse: PujaPrasadOrderResponse) {
    this.razorpayService.initializePayment(
      pujaPrasadOrderResponse.PaymentOrderId, // Order ID
      pujaPrasadOrderResponse.Amount, // Payment amount
      'INR', // Currency
      'Puja Prasad', // Name
      'Payment for Puja Prasad', // Description
      {
        name: this.devoteeDetail.FirstName, // Prefill Name
        email: this.devoteeDetail.Email, // Prefill Email
        contact: this.devoteeDetail.MobileNo, // Prefill Contact Number
      },
      (response) => {
        console.log('Payment successful!', response);
        window.location.href = '/#/mypujaprasadorder/razorpaySuccess/' + response.razorpay_order_id;
      },
      (response) => {
        console.log('Payment Failed!', response);
        window.location.href = '/#/mypujaprasadorder/razorpayFalied/' + response.razorpay_order_id;
      },
      () => {
        console.log('Payment close by user!');
        window.location.href = '/#/mypujaprasadorder/razorpayClosed/' + pujaPrasadOrderResponse.PaymentOrderId;
      }

    );
  }

}



// WEBPACK FOOTER //
// ./src/app/prasad-order/my-puja-prasad-order/my-puja-prasad-order.component.ts